export default "__VITE_ASSET__CVo2IvJi__"